require("jquery.ime/dist/jquery.ime/css/jquery.ime.css")
require("jquery.ime")
// af
require("jquery.ime/dist/jquery.ime/rules/af/af-tilde")
// ak
require("jquery.ime/dist/jquery.ime/rules/ak/ak-qx")
require("jquery.ime/dist/jquery.ime/rules/ak/ak-tilde")
// am
require("jquery.ime/dist/jquery.ime/rules/am/am-transliteration")
// ar
require("jquery.ime/dist/jquery.ime/rules/ar/ar-kbd")
// as
require("jquery.ime/dist/jquery.ime/rules/as/as-avro")
require("jquery.ime/dist/jquery.ime/rules/as/as-bornona")
require("jquery.ime/dist/jquery.ime/rules/as/as-inscript")
require("jquery.ime/dist/jquery.ime/rules/as/as-inscript2")
require("jquery.ime/dist/jquery.ime/rules/as/as-phonetic")
require("jquery.ime/dist/jquery.ime/rules/as/as-rodali")
require("jquery.ime/dist/jquery.ime/rules/as/as-transliteration")
// azb
require("jquery.ime/dist/jquery.ime/rules/azb/azb-kbd")
// bbc
require("jquery.ime/dist/jquery.ime/rules/bbc/batak-qwerty")
// bci
require("jquery.ime/dist/jquery.ime/rules/bci/bci-tilde")
// be
require("jquery.ime/dist/jquery.ime/rules/be/be-kbd")
require("jquery.ime/dist/jquery.ime/rules/be/be-latin")
require("jquery.ime/dist/jquery.ime/rules/be/be-transliteration")
// ber
require("jquery.ime/dist/jquery.ime/rules/ber/ber-tfng")
// bgn
require("jquery.ime/dist/jquery.ime/rules/bgn/bgn-kbd")
// bm
require("jquery.ime/dist/jquery.ime/rules/bm/bm-alt")
require("jquery.ime/dist/jquery.ime/rules/bm/bm-tilde")
// bn
require("jquery.ime/dist/jquery.ime/rules/bn/bn-avro")
require("jquery.ime/dist/jquery.ime/rules/bn/bn-inscript")
require("jquery.ime/dist/jquery.ime/rules/bn/bn-inscript2")
require("jquery.ime/dist/jquery.ime/rules/bn/bn-nkb")
require("jquery.ime/dist/jquery.ime/rules/bn/bn-probhat")
// bo
require("jquery.ime/dist/jquery.ime/rules/bo/bo-ewts")
require("jquery.ime/dist/jquery.ime/rules/bo/bo-sambhota")
// brx
require("jquery.ime/dist/jquery.ime/rules/brx/brx-inscript")
require("jquery.ime/dist/jquery.ime/rules/brx/brx-inscript2")
// byn
require("jquery.ime/dist/jquery.ime/rules/byn/byn-geezim")
// ckb
require("jquery.ime/dist/jquery.ime/rules/ckb/ckb-transliteration-arkbd")
require("jquery.ime/dist/jquery.ime/rules/ckb/ckb-transliteration-fakbd")
require("jquery.ime/dist/jquery.ime/rules/ckb/ckb-transliteration-lakbd")
// cv
require("jquery.ime/dist/jquery.ime/rules/cv/cv-cyr-altgr")
require("jquery.ime/dist/jquery.ime/rules/cv/cv-cyr-numbers")
require("jquery.ime/dist/jquery.ime/rules/cv/cv-lat-altgr")
// cyrl
require("jquery.ime/dist/jquery.ime/rules/cyrl/cyrl-palochka")
// da
require("jquery.ime/dist/jquery.ime/rules/da/da-normforms")
// dag
require("jquery.ime/dist/jquery.ime/rules/dag/dag-alt")
require("jquery.ime/dist/jquery.ime/rules/dag/dag-tilde")
// de
require("jquery.ime/dist/jquery.ime/rules/de/de-transliteration")
// din
require("jquery.ime/dist/jquery.ime/rules/din/din-fqsx")
require("jquery.ime/dist/jquery.ime/rules/din/din-tilde")
// doi
require("jquery.ime/dist/jquery.ime/rules/doi/doi-inscript2")
// ee
require("jquery.ime/dist/jquery.ime/rules/ee/ee-tilde")
// el
require("jquery.ime/dist/jquery.ime/rules/el/el-kbd")
// eo
require("jquery.ime/dist/jquery.ime/rules/eo/eo-h")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-h-f")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-plena")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-q")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-transliteration")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-vi")
require("jquery.ime/dist/jquery.ime/rules/eo/eo-x")
// fa
require("jquery.ime/dist/jquery.ime/rules/fa/fa-kbd")
// ff
require("jquery.ime/dist/jquery.ime/rules/ff/ff-alt")
require("jquery.ime/dist/jquery.ime/rules/ff/ff-tilde")
// fi
require("jquery.ime/dist/jquery.ime/rules/fi/fi-transliteration")
// fo
require("jquery.ime/dist/jquery.ime/rules/fo/fo-normforms")
// fon
require("jquery.ime/dist/jquery.ime/rules/fon/fon-tilde")
// fonipa
require("jquery.ime/dist/jquery.ime/rules/fonipa/ipa-sil")
require("jquery.ime/dist/jquery.ime/rules/fonipa/ipa-x-sampa")
// gaa
require("jquery.ime/dist/jquery.ime/rules/gaa/gaa-cqx")
require("jquery.ime/dist/jquery.ime/rules/gaa/gaa-tilde")
// gom
require("jquery.ime/dist/jquery.ime/rules/gom/gom-inscript2")
// got
require("jquery.ime/dist/jquery.ime/rules/got/got-standard")
// gu
require("jquery.ime/dist/jquery.ime/rules/gu/gu-inscript")
require("jquery.ime/dist/jquery.ime/rules/gu/gu-inscript2")
require("jquery.ime/dist/jquery.ime/rules/gu/gu-phonetic")
require("jquery.ime/dist/jquery.ime/rules/gu/gu-transliteration")
// ha
require("jquery.ime/dist/jquery.ime/rules/ha/ha-tilde")
// he
require("jquery.ime/dist/jquery.ime/rules/he/he-standard-2012")
require("jquery.ime/dist/jquery.ime/rules/he/he-standard-2012-extonly")
// hi
require("jquery.ime/dist/jquery.ime/rules/hi/hi-bolnagri")
require("jquery.ime/dist/jquery.ime/rules/hi/hi-inscript")
require("jquery.ime/dist/jquery.ime/rules/hi/hi-inscript2")
require("jquery.ime/dist/jquery.ime/rules/hi/hi-phonetic")
require("jquery.ime/dist/jquery.ime/rules/hi/hi-transliteration")
// hoc
require("jquery.ime/dist/jquery.ime/rules/hoc/hoc-transliteration")
// hr
require("jquery.ime/dist/jquery.ime/rules/hr/hr-kbd")
// hy
require("jquery.ime/dist/jquery.ime/rules/hy/hy-emslegacy")
require("jquery.ime/dist/jquery.ime/rules/hy/hy-ephonetic")
require("jquery.ime/dist/jquery.ime/rules/hy/hy-ephoneticalt")
require("jquery.ime/dist/jquery.ime/rules/hy/hy-typewriter")
require("jquery.ime/dist/jquery.ime/rules/hy/hy-wmslegacy")
// ig
require("jquery.ime/dist/jquery.ime/rules/ig/ig-tilde")
// is
require("jquery.ime/dist/jquery.ime/rules/is/is-normforms")
// jv
require("jquery.ime/dist/jquery.ime/rules/jv/jv-transliteration")
// ka
require("jquery.ime/dist/jquery.ime/rules/ka/ka-kbd")
require("jquery.ime/dist/jquery.ime/rules/ka/ka-transliteration")
// kab
require("jquery.ime/dist/jquery.ime/rules/kab/kab-tilde")
// kbp
require("jquery.ime/dist/jquery.ime/rules/kbp/kbp-tilde")
// ki
require("jquery.ime/dist/jquery.ime/rules/ki/ki-tilde")
// kk
require("jquery.ime/dist/jquery.ime/rules/kk/kk-arabic")
require("jquery.ime/dist/jquery.ime/rules/kk/kk-kbd")
// km
require("jquery.ime/dist/jquery.ime/rules/km/km-nidakyk")
// kn
require("jquery.ime/dist/jquery.ime/rules/kn/kn-inscript")
require("jquery.ime/dist/jquery.ime/rules/kn/kn-inscript2")
require("jquery.ime/dist/jquery.ime/rules/kn/kn-kgp")
require("jquery.ime/dist/jquery.ime/rules/kn/kn-transliteration")
// ks
require("jquery.ime/dist/jquery.ime/rules/ks/ks-inscript")
require("jquery.ime/dist/jquery.ime/rules/ks/ks-kbd")
// ku
require("jquery.ime/dist/jquery.ime/rules/ku/ku-h")
require("jquery.ime/dist/jquery.ime/rules/ku/ku-tr")
// ky
require("jquery.ime/dist/jquery.ime/rules/ky/ky-cyrl-alt")
// lg
require("jquery.ime/dist/jquery.ime/rules/lg/lg-tilde")
// ln
require("jquery.ime/dist/jquery.ime/rules/ln/ln-tilde")
// lo
require("jquery.ime/dist/jquery.ime/rules/lo/lo-kbd")
// lrc
require("jquery.ime/dist/jquery.ime/rules/lrc/lrc-kbd")
// lud
require("jquery.ime/dist/jquery.ime/rules/lud/lud-transliteration")
// lut
require("jquery.ime/dist/jquery.ime/rules/lut/lut-tulalip")
// mai
require("jquery.ime/dist/jquery.ime/rules/mai/mai-inscript")
require("jquery.ime/dist/jquery.ime/rules/mai/mai-inscript2")
// mg
require("jquery.ime/dist/jquery.ime/rules/mg/mg-tilde")
// mh
require("jquery.ime/dist/jquery.ime/rules/mh/mh")
// ml
require("jquery.ime/dist/jquery.ime/rules/ml/ml-inscript")
require("jquery.ime/dist/jquery.ime/rules/ml/ml-inscript2")
require("jquery.ime/dist/jquery.ime/rules/ml/ml-transliteration")
// mn
require("jquery.ime/dist/jquery.ime/rules/mn/mn-cyrl")
require("jquery.ime/dist/jquery.ime/rules/mn/mn-todo")
require("jquery.ime/dist/jquery.ime/rules/mn/mn-todoali")
require("jquery.ime/dist/jquery.ime/rules/mn/mn-trad")
require("jquery.ime/dist/jquery.ime/rules/mn/mn-tradali")
require("jquery.ime/dist/jquery.ime/rules/mn/phagspa")
// mnc
require("jquery.ime/dist/jquery.ime/rules/mnc/mnc")
require("jquery.ime/dist/jquery.ime/rules/mnc/mnc-ali")
// mni
require("jquery.ime/dist/jquery.ime/rules/mni/mni-inscript2")
// mr 
require("jquery.ime/dist/jquery.ime/rules/mr/mr-inscript")
require("jquery.ime/dist/jquery.ime/rules/mr/mr-inscript2")
require("jquery.ime/dist/jquery.ime/rules/mr/mr-phonetic")
require("jquery.ime/dist/jquery.ime/rules/mr/mr-transliteration")
// my
require("jquery.ime/dist/jquery.ime/rules/my/my-mm3")
require("jquery.ime/dist/jquery.ime/rules/my/my-xkb")
// nb
require("jquery.ime/dist/jquery.ime/rules/nb/nb-normforms")
require("jquery.ime/dist/jquery.ime/rules/nb/nb-tildeforms")
// ne
require("jquery.ime/dist/jquery.ime/rules/ne/ne-inscript")
require("jquery.ime/dist/jquery.ime/rules/ne/ne-inscript2")
require("jquery.ime/dist/jquery.ime/rules/ne/ne-rom")
require("jquery.ime/dist/jquery.ime/rules/ne/ne-trad")
require("jquery.ime/dist/jquery.ime/rules/ne/ne-transliteration")
// nqo
require("jquery.ime/dist/jquery.ime/rules/nqo/nqo-standard-qwerty")
require("jquery.ime/dist/jquery.ime/rules/nqo/nqo-transliteration")
// nso
require("jquery.ime/dist/jquery.ime/rules/nso/nso-tilde")
// or 
require("jquery.ime/dist/jquery.ime/rules/or/or-OdiScript")
require("jquery.ime/dist/jquery.ime/rules/or/or-inscript")
require("jquery.ime/dist/jquery.ime/rules/or/or-inscript2")
require("jquery.ime/dist/jquery.ime/rules/or/or-lekhani")
require("jquery.ime/dist/jquery.ime/rules/or/or-phonetic")
require("jquery.ime/dist/jquery.ime/rules/or/or-transliteration")
// roa-tara
require("jquery.ime/dist/jquery.ime/rules/roa-tara/roa-tara")
// ru
require("jquery.ime/dist/jquery.ime/rules/ru/ru-jcuken")
require("jquery.ime/dist/jquery.ime/rules/ru/ru-kbd")
require("jquery.ime/dist/jquery.ime/rules/ru/ru-phonetic")
require("jquery.ime/dist/jquery.ime/rules/ru/ru-yawerty")
// sa
require("jquery.ime/dist/jquery.ime/rules/sa/sa-iast")
require("jquery.ime/dist/jquery.ime/rules/sa/sa-inscript")
require("jquery.ime/dist/jquery.ime/rules/sa/sa-inscript2")
require("jquery.ime/dist/jquery.ime/rules/sa/sa-transliteration")
// sah
require("jquery.ime/dist/jquery.ime/rules/sah/sah-transliteration")
// sat
require("jquery.ime/dist/jquery.ime/rules/sat/sat-inscript2")
require("jquery.ime/dist/jquery.ime/rules/sat/sat-inscript2-ol-chiki")
require("jquery.ime/dist/jquery.ime/rules/sat/sat-sarjom-baha")
// sd
require("jquery.ime/dist/jquery.ime/rules/sd/sd-inscript2")
// sdh
require("jquery.ime/dist/jquery.ime/rules/sdh/sdh-kbd")
// se
require("jquery.ime/dist/jquery.ime/rules/se/se-normforms")
// ses
require("jquery.ime/dist/jquery.ime/rules/ses/ses-tilde")
// sg
require("jquery.ime/dist/jquery.ime/rules/sg/sg-tilde")
// si
require("jquery.ime/dist/jquery.ime/rules/si/si-singlish")
require("jquery.ime/dist/jquery.ime/rules/si/si-wijesekara")
// sjo
require("jquery.ime/dist/jquery.ime/rules/sjo/sjo")
// sk
require("jquery.ime/dist/jquery.ime/rules/sk/sk-kbd")
// sr
require("jquery.ime/dist/jquery.ime/rules/sr/sr-kbd")
// st
require("jquery.ime/dist/jquery.ime/rules/st/st-tilde")
// sv
require("jquery.ime/dist/jquery.ime/rules/sv/sv-normforms")
// Tamil
require("jquery.ime/dist/jquery.ime/rules/ta/ta-99")
require("jquery.ime/dist/jquery.ime/rules/ta/ta-bamini")
require("jquery.ime/dist/jquery.ime/rules/ta/ta-inscript")
require("jquery.ime/dist/jquery.ime/rules/ta/ta-transliteration")
// te
require("jquery.ime/dist/jquery.ime/rules/te/te-apple")
require("jquery.ime/dist/jquery.ime/rules/te/te-inscript")
require("jquery.ime/dist/jquery.ime/rules/te/te-inscript2")
require("jquery.ime/dist/jquery.ime/rules/te/te-modular")
require("jquery.ime/dist/jquery.ime/rules/te/te-transliteration")
// th
require("jquery.ime/dist/jquery.ime/rules/th/th-kedmanee")
require("jquery.ime/dist/jquery.ime/rules/th/th-pattachote")
// ti
require("jquery.ime/dist/jquery.ime/rules/ti/ti-geezim")
// tig
require("jquery.ime/dist/jquery.ime/rules/tig/tig-geezim")
// udm
require("jquery.ime/dist/jquery.ime/rules/udm/udm-alt")
// ug
require("jquery.ime/dist/jquery.ime/rules/ug/ug-kbd")
// uk
require("jquery.ime/dist/jquery.ime/rules/uk/uk-kbd")
// ur
require("jquery.ime/dist/jquery.ime/rules/ur/ur-phonetic")
require("jquery.ime/dist/jquery.ime/rules/ur/ur-transliteration")
// uz
require("jquery.ime/dist/jquery.ime/rules/uz/uz-kbd")
// vai
require("jquery.ime/dist/jquery.ime/rules/vai/vai-transliteration")
// ve
require("jquery.ime/dist/jquery.ime/rules/ve/ve-tilde")
// vec
require("jquery.ime/dist/jquery.ime/rules/vec/vec-GVU")
// wo
require("jquery.ime/dist/jquery.ime/rules/wo/wo-alt")
require("jquery.ime/dist/jquery.ime/rules/wo/wo-tilde")
// yo
require("jquery.ime/dist/jquery.ime/rules/yo/yo-alt")
require("jquery.ime/dist/jquery.ime/rules/yo/yo-tilde")
// zh
require("jquery.ime/dist/jquery.ime/rules/zh/zh-pinyin-transliteration")


